import '../theme.css';
import { Header, Navigation } from '../partials/header';
import { useEffect } from 'react';

function Home() {
    useEffect(() => {
        document.title = "Croptimizer Home";
    }, [])
    
    return (
        <div className="theme-container">
            <Navigation />

            <div className="main-content">
                <Header />

                {/* Page Content */}
                <div className="page-content">
                    <div className="content-wrapper">
                        <h1 className="page-heading">
                            Welcome to Stardew Croptimizer
                        </h1>
                        <div className="content-card">
                            <h2 className="card-title">
                                Welcome!
                            </h2>
                            <p className="card-text">
                                Welcome to the Stardew Croptimizer! In order to use our website, you need to have an account.
                                <br />
                                If you already have an account, you can login at the top right.
                                <br />
                                Otherwise, you can create an account in the top right as well.
                                <img src="/images/tutorials/CreateAccount.png" alt='CreateAccountInstructions' id="tutorial-image"/>
                            </p>

                            <h2 className='card-title'>So what do we offer?</h2>
                            <div className='card-text'>
                                <h3 className='card-title'>Calendar: </h3>
                                <div className="calendar-preview">
                                    Our Calendar allows you to plan out when to plant crops. 
                                    It will show how long they'll take to grow with different fertilizers & skills.
                                    <div id="calendar-tutorial-images">
                                        <img src="/images/tutorials/CalendarSelection.png" alt="Calendar with potential crops" id="calendar-image" />
                                        <img src="/images/tutorials/GrowTimes.png" alt="Crop Grow Times" id="tutorial-image"/>
                                    </div>
                                    If a crop regrows, the calendar will take that into account and display all the days it can be harvested.
                                    <br />
                                    It also warns you if a crop is going to be out of season/die before you can harvest it.
                                    <div id="calendar-tutorial-images">
                                        <img src="/images/tutorials/CropRegrow.png" alt="Calendar showing crop regrowing" id="calendar-image" />
                                        <img src="/images/tutorials/OutOfSeason.png" alt="Calendar showing out of season crops" id="tutorial-image"/>
                                    </div>
                                </div>

                                <h3 className='card-title'>Profit Calculator:</h3>
                                <div className='calculator-preview'>
                                    Our Profit Calculator allows you to determine how much gold you'll make from the crops you plant.
                                    <br />
                                    Select the crop and fertilizer, then let us do the math!
                                    <br />
                                    The following example is using 20 pumpkins using Hyper-Speed Gro with Tiller & Agriculturalist.
                                    <div id="calculator-tutorial-images">
                                        <img src="/images/tutorials/ProfitCalculator.png" alt="Profit Calculator" id="calculator-image"/>
                                        <img src="/images/tutorials/CalculatorOutput.png" alt="Profit Calculator Output" id="tutorial-image"/>
                                    </div>
                                </div>

                                <h3 className='card-title'>Still not convinced?</h3>
                                Let us know how we can improve! Send us an email at Feedback@StardewCroptimizer.com
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;